import { useQuery, useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../../js/api/axios";
import { queryClient } from "../queryClient";

export const fetchSavedColors = async () => {
  const response = await axiosInstance.get(
    `/umbraco/api/savedColours/getSavedColours/`
  );
  return response.data;
};

export const saveColor = async (url) => {
  const response = await axiosInstance.post(url);
  return response.data;
};

export const deleteColor = async (url) => {
  const response = await axiosInstance.post(url);
  return response.data;
};

export const useSavedColors = () => {
  return useQuery({
    queryKey: ["my-saved-colors-dialog"],
    queryFn: fetchSavedColors,
  });
};

export const useCmsSaveColor = () => {
  return useMutation({
    mutationFn: async ({ url }) => {
      await saveColor(url);
    },
    onSuccess: (_, { successHandler }) => {
      queryClient.invalidateQueries("my-saved-colors-dialog").then((data) => {
        if (successHandler) {
          successHandler(data);
        }
      });
    },
    onError: (_, { errorHandler }) => {
      if (errorHandler) {
        errorHandler();
      }
    },
  });
};

export const useCmsDeleteColor = () => {
  return useMutation({
    mutationFn: async ({ url }) => {
      await deleteColor(url);
    },
    onSuccess: (_, { successHandler }) => {
      queryClient.invalidateQueries("my-saved-colors-dialog").then((data) => {
        if (successHandler) {
          successHandler(data);
        }
      });
    },
    onError: (_, { errorHandler }) => {
      if (errorHandler) {
        errorHandler();
      }
    },
  });
};
